import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=bf2bce42"
import script from "./ImportExport.vue?vue&type=script&lang=js"
export * from "./ImportExport.vue?vue&type=script&lang=js"
import style0 from "./ImportExport.vue?vue&type=style&index=0&id=bf2bce42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports